export const NOTIFICATIONS_EVENT = 'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated';
